export default __webpack_public_path__ + "static/media/success-add-account.364511bc.svg";